import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '@shared/modal/components/modal.component';
import { ModalHostDirective } from '@shared/modal/directives/modal-host.directive';
import { ModalSizePipe } from './pipes/modal-size.pipe';


@NgModule({
	declarations: [
		ModalComponent,
		ModalHostDirective,
		ModalSizePipe
	],
	imports: [
		CommonModule
	],
	exports: [
		ModalComponent,
		ModalHostDirective
	]
})
export class ModalModule {
}
